import { supabase } from './supabase-client'
import type { Sound } from './supabase-types'
import type { RealtimeChannel } from '@supabase/supabase-js'

export type DownloadCountUpdate = {
  sound_id: string
  downloads: number
  previous_downloads: number
}

const activeChannels = new Map<string, RealtimeChannel>()

export function subscribeDownloadCount(
  soundId: string,
  callback: (update: DownloadCountUpdate) => void
): string {
  const channelId = `sound-downloads-${soundId}-${Date.now()}`

  const channel = supabase
    .channel(channelId)
    .on(
      'postgres_changes',
      {
        event: 'UPDATE',
        schema: 'public',
        table: 'sounds',
        filter: `id=eq.${soundId}`
      },
      (payload) => {
        const newSound = payload.new as Sound
        const oldSound = payload.old as Sound

        if (newSound.downloads !== oldSound.downloads) {
          callback({
            sound_id: soundId,
            downloads: newSound.downloads,
            previous_downloads: oldSound.downloads
          })
        }
      }
    )
    .subscribe()

  activeChannels.set(channelId, channel)
  return channelId
}

export async function unsubscribe(channelId: string): Promise<void> {
  const channel = activeChannels.get(channelId)

  if (channel) {
    await supabase.removeChannel(channel)
    activeChannels.delete(channelId)
  }
}
